import type { KnownVoiceDisplayName } from '@listening/api-contract/schemas';
import { Schema } from 'effect';

export const DemoVoiceKey = Schema.Literals([
  'Scarlett',
  'Hugh',
  'Amy',
  'Justin',
] satisfies readonly KnownVoiceDisplayName[]);
export type DemoVoiceKey = typeof DemoVoiceKey.Type;
export const DEMO_VOICE_KEYS = DemoVoiceKey.literals;

export const DemoVariant = Schema.Literals(['research', 'general']);
export type DemoVariant = typeof DemoVariant.Type;
export const DEMO_VARIANTS = DemoVariant.literals;

export const RESEARCH_BODY_1 =
  'Prospect theory predicts that people weigh potential losses more heavily than equivalent gains.';
export const RESEARCH_CITATION = '(Kahneman & Tversky, 1979)¹';
export const RESEARCH_BODY_2 =
  'This asymmetry, known as loss aversion, reshapes how we model decisions under risk.';
export const GENERAL_BODY =
  "Most people don't have a reading problem. They have a time problem. Listening turns your reading list into something you get through while you walk, commute, or cook dinner.";

export function demoWords(variant: DemoVariant): readonly string[] {
  return variant === 'general'
    ? GENERAL_BODY.split(' ')
    : [...RESEARCH_BODY_1.split(' '), ...RESEARCH_BODY_2.split(' ')];
}

export function demoSpokenText(variant: DemoVariant): string {
  return demoWords(variant).join(' ');
}

export function demoClipPath(
  variant: DemoVariant,
  voice: DemoVoiceKey,
): string {
  return `/funnel-demo/${variant}-${voice.toLowerCase()}.mp3`;
}
